import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Container,Row,Col} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import moment from "moment";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import "../../vodafone.css"
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/de';
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import TextField from '@material-ui/core/TextField';
import vodafoneLogo from "../../media/icons/vf-logo.png";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

class StageAppointmentSelectConfirm extends React.Component {

    // initialize Component state
    state = { warningMessageBox: false, warningTextYesAtHome: false, warningTextNoAtHome: false, redButtonDisabled: true };

    constructor(props){
        super(props);
    }


    /**
     * update Message
     * @param event
     */
    updateMessage = (event) => {

        console.log("updateMessage / event.target.id: " + event.target.id);
        console.log("updateMessage / state.warningMessageBox: " + this.state.warningMessageBox);

        this.setState({warningMessageBox: true});
		this.setState({redButtonDisabled: false});

        // set warningMessageBox: true so that message box will be shown
        if( event.target.id == "yesAtHome" ) {
            // setState triggers another execution of "render()" method
            this.setState({warningTextYesAtHome: true});
            this.setState({warningTextNoAtHome: false});

        // set warningMessageBox: false so that message box will be hidden
        } else {
            // setState triggers another execution of "render()" method
            this.setState({warningTextYesAtHome: false});
            this.setState({warningTextNoAtHome: true});
        }
    };


    /**
     * render
     * @returns {*}
     */
    render() {

        var confirm_title            = "confirm_title_placeholder";
        var confirm_body             = "confirm_body_placeholder";

        // select text/elements depending on TAM (RESULT_CODE)
        switch( parseInt( this.props.ds360APIResult.RESULT_CODE ) ) {

            // setze Texte für TAM6000, TAM6001 und TAM6002 (sind identisch)
            case 6000:
            case 6001:
            case 6002:
			case 6003:
                confirm_title            = "tam6000_calendar_confirmed_title";
                confirm_body             = "tam6000_calendar_confirmed_body";
                break;
        }

        return <Container>
            <MobileView>
                <Row className={"header"}>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
                <Row style={{paddingTop:"5vh"}}>
                    <Col xs={{ size: 12 }}>
                            <Header
                                textResource={confirm_title}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 12 }}>
                            <TextBody
                                textResource={confirm_body}
                            />
                    </Col>
                </Row>
                <Row className={'fixed-to-bottom'} style={{paddingBottom:"20px"}}>
                    <Col xs={{ size: 12 }}>
                        <Row>
                            <Col xs={{ size: 12 }}>
                                <Row style={{paddingLeft:"15px", paddingRight:"15px"}}>
                                    <Col xs={{ size: 12 }} className="verticalAlign">
                                        <div class="selectedAppointmentContainer selected full-width">
                                            <Row>
                                                <Col xs={{ size: 2 }} className="verticalAlign" style={{marginLeft:"18px"}}>
                                                    <img class="technikerImg" src="img/techniker-weiss.png" />
                                                </Col>
                                                <Col xs={{ size: 9, offset: 0 }}>
													<span>
                                                        <b>{moment.utc(this.props.selectedDate).format("dddd")},&nbsp;{moment.utc(this.props.selectedDate).format("DD.MM.")}</b><br />
                                                        {moment.utc(this.props.selectedDate).format("H")} - {moment.utc(this.props.selectedDate).add(5, 'hours').format("H")} Uhr
                                                    </span>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </MobileView>

            <BrowserView>
    			<Row className={"header desktop"}>
                    <Col xs={12}>
                        <div className={"container"}>
                            <Row>
                                <Col xs={2} style={{marginLeft:"-15px"}}>
                                    <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row style={{paddingTop:"20vh"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                            <Header
                                textResource={confirm_title}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                            <TextBody
                                textResource={confirm_body}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <Row>
                            <Col xs={{ size: 12 }} className="verticalAlign">
                                <div class="selectedAppointmentContainer selected">
                                    <Row>
                                        <Col xs={{ size: 1 }} className="verticalAlign" style={{marginLeft:"18px"}}>
                                            <img class="technikerImg" src="img/techniker-weiss.png" />
                                        </Col>
                                        <Col xs={{ size: 10, offset: 0 }}>
											<span>
                                                <b>{moment.utc(this.props.selectedDate).format("dddd")},&nbsp;{moment.utc(this.props.selectedDate).format("DD.MM.")}</b><br />
                                                {moment.utc(this.props.selectedDate).format("H")} - {moment.utc(this.props.selectedDate).add(5, 'hours').format("H")} Uhr
                                            </span>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }

}

export default translate("translations")(StageAppointmentSelectConfirm);